import { useEffect } from "react";
import { useClerk, useSession } from "@clerk/react";

const IDLE_MS = 30 * 60 * 1000;
const EVENTS = ["pointerdown", "keydown", "mousemove", "scroll", "touchstart"];
const KEY = "jm_admin_last_active";

// Signs the admin out after 30 minutes without activity (also across reloads, tabs and after the laptop sleeps)
export default function IdleSignOut() {
  const { signOut } = useClerk();
  const { session } = useSession();
  const started = session?.createdAt ? new Date(session.createdAt).getTime() : Date.now();

  useEffect(() => {
    let last = 0;
    const touch = () => {
      const now = Date.now();
      if (now - last > 5000) {
        last = now;
        localStorage.setItem(KEY, String(now));
      }
    };
    const check = () => {
      const seen = Math.max(Number(localStorage.getItem(KEY) || 0), started);
      if (Date.now() - seen >= IDLE_MS) {
        localStorage.removeItem(KEY);
        sessionStorage.setItem("jm_idle_signout", "1");
        signOut({ redirectUrl: "/sign-in" });
      }
    };
    check();
    EVENTS.forEach((e) => window.addEventListener(e, touch, { passive: true }));
    const id = setInterval(check, 30000);
    document.addEventListener("visibilitychange", check);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", check);
      EVENTS.forEach((e) => window.removeEventListener(e, touch));
    };
  }, [signOut, started]);

  return null;
}
